
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import QuizStart from "../components/QuizStart";
import Quiz from "../components/Quiz";
import ResultsSummary from "../components/ResultsSummary";
import { calculateResults } from "../utils/quizUtils";
import { quizQuestions } from "../data/quizQuestions";

const QuizPage: React.FC = () => {
  const navigate = useNavigate();
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizFinished, setQuizFinished] = useState(false);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  
  const handleStartQuiz = () => {
    setQuizStarted(true);
    setQuizFinished(false);
    setAnswers({});
  };
  
  const handleFinishQuiz = (selectedAnswers: Record<string, string>) => {
    setAnswers(selectedAnswers);
    
    // Store result in sessionStorage for the results page
    const result = calculateResults(selectedAnswers);
    sessionStorage.setItem('quizResult', JSON.stringify(result));
    
    // Either show results directly or navigate to results page
    setQuizFinished(true);
    // Uncomment to navigate to results page instead
    // navigate('/results');
  };
  
  const handleRestartQuiz = () => {
    setQuizStarted(true);
    setQuizFinished(false);
    setAnswers({});
  };
  
  return (
    <Layout>
      <div className="container-custom py-12">
        {!quizStarted && !quizFinished && (
          <QuizStart onStart={handleStartQuiz} />
        )}
        
        {quizStarted && !quizFinished && (
          <Quiz 
            questions={quizQuestions}
            onFinish={handleFinishQuiz}
          />
        )}
        
        {quizFinished && (
          <ResultsSummary 
            result={calculateResults(answers)}
            onRestart={handleRestartQuiz}
          />
        )}
      </div>
    </Layout>
  );
};

export default QuizPage;
